import { render, staticRenderFns } from "./BetGuide.vue?vue&type=template&id=61cf34e0&"
import script from "./BetGuide.vue?vue&type=script&lang=js&"
export * from "./BetGuide.vue?vue&type=script&lang=js&"
import style0 from "./BetGuide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BetGuide.vue"
export default component.exports